import { http, HttpResponse } from 'msw';
import {
  getActivities,
  getClaims,
  getInsurances,
  getInvoices,
  getNotes,
  getQuotations,
  getTasks,
} from '@maia/shared';

function baseResponse<T>(response: T, page?: number, limit?: number) {
  return {
    statusCode: 200,
    response,
    success: true,
    error: null,
    pagination: {
      page_number: page,
      page_size: limit,
      total_results: 110,
      total_pages: 11,
    },
  };
}

export const handlers = [
  http.get('http://localhost:3000/insurances', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const page = parseInt(url.searchParams.get('page') ?? '1');
    const insurances = getInsurances(limit);
    return HttpResponse.json(baseResponse(insurances, page, limit));
  }),
  http.get('http://localhost:3000/insurances/:guid', () => {
    const insurances = getInsurances(1)[0];
    return HttpResponse.json(baseResponse(insurances));
  }),
  http.get('http://localhost:3000/insurances/:guid/claims', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const page = parseInt(url.searchParams.get('page') ?? '1');
    const claims = getClaims(limit);
    return HttpResponse.json(baseResponse(claims, page, limit));
  }),
  http.get(
    'http://localhost:3000/insurances/:guid/activities',
    ({ request }) => {
      const url = new URL(request.url);
      const limit = parseInt(url.searchParams.get('limit') ?? '10');
      const page = parseInt(url.searchParams.get('page') ?? '1');
      const activities = getActivities(limit);
      return HttpResponse.json(baseResponse(activities, page, limit));
    },
  ),
  http.get('http://localhost:3000/insurances/:guid/notes', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const page = parseInt(url.searchParams.get('page') ?? '1');
    const notes = getNotes(limit);
    return HttpResponse.json(baseResponse(notes, page, limit));
  }),
  http.get(
    'http://localhost:3000/insurances/:guid/quotations',
    ({ request }) => {
      const url = new URL(request.url);
      const limit = parseInt(url.searchParams.get('limit') ?? '10');
      const page = parseInt(url.searchParams.get('page') ?? '1');
      const quotations = getQuotations(limit);
      return HttpResponse.json(baseResponse(quotations, page, limit));
    },
  ),
  http.get('http://localhost:3000/insurances/:guid/tasks', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const page = parseInt(url.searchParams.get('page') ?? '1');
    const tasks = getTasks(limit);
    return HttpResponse.json(baseResponse(tasks, page, limit));
  }),
  http.get('http://localhost:3000/insurances/:guid/invoices', ({ request }) => {
    const url = new URL(request.url);
    const limit = parseInt(url.searchParams.get('limit') ?? '10');
    const page = parseInt(url.searchParams.get('page') ?? '1');
    const invoices = getInvoices(limit);
    return HttpResponse.json(baseResponse(invoices, page, limit));
  }),
];
